import React, { useState, useMemo, useEffect } from 'react';
import ComplianceActivityResourceModal from './resource_modal';

const modulesConfigurations = () => {
  return {
    laboral_hiring: {
      indexEntitiesPath: Routes.laboral_hirings_path,
      entityKeyName: 'hirings',
    },
    laboral_employee: {
      indexEntitiesPath: Routes.laboral_employees_path,
      entityKeyName: 'employees',
    },
    abstract: {
      indexEntitiesPath: Routes.abstract_entities_path,
      entityKeyName: 'entities',
    }
  }
}

const getModuleConfiguration = (module) => {
  if(!module){
    return {};
  } else if (_.includes(_.split(module, '_'), 'abstract')) {
    return modulesConfigurations()["abstract"];
  } else {
    return modulesConfigurations()[module];
  }
}

const ComplianceActivityResourceModuleSelect = (props) => {
  const {
    activity,
    formName,
    data: {
      resourceLabel,
      moduleGroupedOptions,
    },
    callbacks: {
      onChangeActivity: callbackOnChangeActivity
    }
  } = props;

  // Almacenar los filtros de la tabla
  const [filterrific, setFilterrific] = useState({});

  const {
    indexEntitiesPath,
    entityKeyName,
  } = getModuleConfiguration(activity?.resource_module_name) || {};

  const currentEntityTypeId = useMemo(() => {
    let arrayModuleName = _.split(activity?.resource_module_name, '_');
    if(!activity?.resource_module_name || !_.includes(arrayModuleName, 'abstract')) return '';

    return _.last(arrayModuleName);
  }, [activity?.resource_module_name]);

  useEffect(() => {
    callbackOnChangeActivity({ target: { value: currentEntityTypeId }}, 'abstract_entity_type_id' );
  }, [currentEntityTypeId]);

  const defaultRequestParams = useMemo(() => {
    let requestParams = {};

    if(_.includes(_.split(activity?.resource_module_name, '_'), 'abstract')){
      requestParams = {
        current_entity_type_id: currentEntityTypeId,
      };
    }
    return requestParams;
  }, [activity?.resource_module_name]);

  const resourceModal = () => {
    return (
      <ComplianceActivityResourceModal
        activity={activity}
        resourceLabel={resourceLabel}
        filterrific={filterrific}
        totalRecords={activity?.total_entity_records || 0}
        configuration={{
          indexEntitiesPath: indexEntitiesPath,
          entityKeyName: entityKeyName,
          defaultRequestParams: defaultRequestParams,
        }}
        callbacks={{
          onSetFilterrific: setFilterrific,
          onChangeActivity: callbackOnChangeActivity
        }}
      />
    );
  };

  return (
    <div className="pt-2">
      <select
        className="form-select"
        name={`${ formName }[resource_module_name]`}
        value={activity?.resource_module_name || ''}
        onChange={ e => callbackOnChangeActivity(e, 'resource_module_name') }
      >
        <option value="">{ "Seleccione un módulo"}</option>
        {_.map(moduleGroupedOptions, (group) => {
          return (
            <optgroup key={_.uniqueId('optgroup-')} label={group.label}>
              {_.map(group.options, (option) => (
                <option key={_.uniqueId('option-')} value={option.value}>{option.label}</option>
              ))}
            </optgroup>
          )
        })}
      </select>
      <small className="text-muted">{ I18n.t('activerecord.help.compliance/activity.resource_module_name') }</small>

      {resourceModal()}
    </div>
  );
};

export default ComplianceActivityResourceModuleSelect;